import type { ErrorADT } from "pb.safe";
import { createContext, useContext } from "react";

import type { Client as WsClient } from "../../../../@lib-appsync-ws";
import type { ApiClient } from "./api-client";

export type RouteContext = {
	apiClient: ApiClient;
	wsClient: WsClient;
	getNowDate: () => Date;
	healthcheck: (
		deviceId: string,
	) => Promise<undefined | ErrorADT<"NetworkError">>;
};

export const RouteContext = createContext<RouteContext | undefined>(undefined);

export function useRouteContext(): RouteContext {
	const context = useContext(RouteContext);
	if (!context) {
		throw new Error("Accessing ApiClient outside of context.");
	}
	return context;
}
